/*
    Copyright (C) 2024 - Workforce Navigator - Southwest Airlines
*/

import { generateClient } from 'aws-amplify/api';
import UserService from './user-service/user-service.jsx';
import generateUUID from '../utils/generateUUID.js';
import logger from '../utils/logger.js';

const GraphQLRequest = (query, variables, headers) => {
  const client = generateClient();
  const accessToken = UserService?.getTokens()?.accessToken;
  return client.graphql(
    {
      query,
      variables,
      authToken: accessToken
    },
    { ...headers }
  );
};

const GraphQLQueryRequest = async (query, variables, headers) => {
  const transactionId = generateUUID();
  let response;
  let error;
  headers = { ...headers, transactionId };
  const startTime = Date.now();
  try {
    response = await GraphQLRequest(query, variables, headers);
  } catch (err) {
    error = err;
    console.log(err);
  } finally {
    const endTime = Date.now();
    const timeTaken = endTime - startTime;
    logger({
      req: { query, variables, headers },
      res: { response },
      headers: { transactionId },
      error,
      timeTaken
    });
  }
  return response;
};

const GraphQLMutationRequest = async (mutation, variables, headers) => {
  const transactionId = generateUUID();
  const startTime = Date.now();
  let response;
  let error;
  console.log('mutation:', mutation);
  try {
    headers = { ...headers, transactionId };
    response = await GraphQLRequest(mutation, variables, headers);
  } catch (err) {
    error = err;
    console.log(err);
  } finally {
    const endTime = Date.now();
    const timeTaken = endTime - startTime;
    logger({
      req: { mutation, variables, headers },
      res: { response },
      headers: { transactionId },
      error,
      timeTaken
    });
  }
  return response;
};
// Explicitly bind to global object
const GraphQLService = {
  GraphQLQueryRequest,
  GraphQLMutationRequest,
  GraphQLRequest
};

// Bind explicitly to global object if needed
if (typeof window !== 'undefined') {
  window.GraphQLService = GraphQLService;
}

export default GraphQLService;
